import React from 'react';
import TpClientInvoiceItem from '../../../Domain/TpClientInvoiceItem';
import TpClientInvoiceService from '../../../Services/TpClientInvoiceService';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import TpClientInvoiceStatusEnum from '../../../Enums/ClientInvoiceStatusEnum';
import ClientInvoiceFormOptionsArray from '../../../Enums/ClientInvoiceFormOptionsArray';
import ClientInvoiceReportOrderOptionsArray from '../../../Enums/ClientInvoiceReportOrderOptionsArray';
import ClientInvoiceReportGroupOptionsArray from '../../../Enums/ClientInvoiceReportGroupOptionsArray';

export default class EditTpClientInvoiceWindowDescription extends React.Component {
  static titleForCreate = 'Add New Client Invoice';
  static titleForEdit = (editedItem) => `Edit Client Invoice (#${editedItem.TpClientInvoiceId})`;
  static itemType = TpClientInvoiceItem;
  // Only the edited item says which jobs to add: Generate Invoice puts the ticked jobs on it, while an edit or a
  // copy opened from the invoice list has none.
  static serviceFunction = (editedItem) => TpClientInvoiceService.EditInvoice(editedItem);
  static waitForServiceFunction = (editedItem) => editedItem.AllItemsInTheSearchSetAreSelected !== true;
  static lastContactId = '';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      hide: (item) => item.Status === TpClientInvoiceStatusEnum.Paid && !item.IsCopyAction,
      fields: [
        {
          fieldName: 'CaspianClientName',
          label: 'Client Name',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'CurrencyId',
          label: 'Currency *',
          className: 'col-12',
          type: InputTypesEnum.ActiveCurrencySelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          disabled: (item) => item.Status !== TpClientInvoiceStatusEnum.Draft && !item.IsCopyAction,
        },
        {
          fieldName: 'ContactId',
          label: 'Bill To Contact *',
          className: 'col-12',
          type: InputTypesEnum.ContactSelectForNewInvoice,
          validityChecker: ValidityHelper.forRequiredSelectField,
          disabled: (item) => item.Status !== TpClientInvoiceStatusEnum.Draft && !item.IsCopyAction,
          idFilter: 'CaspianClientId',
          onFieldChange: EditTpClientInvoiceWindowDescription.onContactChange,
        },
        {
          fieldName: 'Vatnumber',
          label: 'Billing To Client Tax # *',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.validityCheckerforVatNumber,
          disabled: (item) => item.Status === TpClientInvoiceStatusEnum.Paid && !item.IsCopyAction,
        },
        {
          fieldName: 'BillToClientName',
          label: 'Bill To Client Name',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => item.Status !== TpClientInvoiceStatusEnum.Draft && !item.IsCopyAction,
        },
        {
          fieldName: 'OfficeName',
          label: 'Office',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'DaysToPay',
          label: 'Days To Pay *',
          className: 'col-12',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
          disabled: (item) => item.Status !== TpClientInvoiceStatusEnum.Draft && !item.IsCopyAction,
        },
        {
          fieldName: 'LatePaymentInterestRate',
          label: 'Late Fee % *',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
          disabled: (item) => item.Status !== TpClientInvoiceStatusEnum.Draft && !item.IsCopyAction,
        },
        {
          fieldName: () => new Date(),
          label: 'Invoiced On *',
          className: 'col-12',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => item.Status !== TpClientInvoiceStatusEnum.Draft && !item.IsCopyAction,
        },
        {
          fieldName: (item) => dateTimeHelper.addDaysToDate(new Date(), item.DaysToPay ? item.DaysToPay : 0),
          label: 'Due On *',
          className: 'col-12',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.AlwaysFlawless,
          disabled: (item) => item.Status !== TpClientInvoiceStatusEnum.Draft && !item.IsCopyAction,
        },
        {
          fieldName: 'FulfillmentDate',
          label: 'Fullfillment Date *',
          className: 'col-12',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.forRequiredDateTimeLaterThanToday,
          disabled: (item) => item.Status !== TpClientInvoiceStatusEnum.Draft && !item.IsCopyAction,
          hide: (item) => item.OfficeId && parseInt(item.OfficeId) !== 9,
        },
      ],
    },
    {
      label: 'Invoice Details',
      fields: [
        {
          fieldName: 'InvoiceNumber',
          label: 'Client Invoice #',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'InternalReferenceNumber',
          label: 'Internal Reference Number',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => item.Status === TpClientInvoiceStatusEnum.Paid && !item.IsCopyAction,
        },
        {
          fieldName: 'Ponumber',
          label: 'Purchase Order #',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => item.Status === TpClientInvoiceStatusEnum.Paid && !item.IsCopyAction,
        },
        {
          fieldName: 'DefaultReportName',
          label: 'Invoice Form *',
          className: 'col-12',
          type: InputTypesEnum.Select,
          validityChecker: ValidityHelper.forRequiredSelectField,
          selectvalues: ClientInvoiceFormOptionsArray,
          hide: (item) => item.Status === TpClientInvoiceStatusEnum.Paid && !item.IsCopyAction,
        },
        {
          fieldName: 'ReportOrder',
          label: 'Form Order',
          className: 'col-12',
          type: InputTypesEnum.Select,
          validityChecker: ValidityHelper.AlwaysFlawless,
          selectvalues: ClientInvoiceReportOrderOptionsArray,
          showFilterAt: 2,
          hide: (item) => item.Status === TpClientInvoiceStatusEnum.Paid && !item.IsCopyAction,
        },
        {
          fieldName: 'ReportGroup1',
          label: 'Form Group 1',
          className: 'col-12',
          type: InputTypesEnum.Select,
          validityChecker: ValidityHelper.AlwaysFlawless,
          selectvalues: ClientInvoiceReportGroupOptionsArray,
          hide: (item) => item.Status === TpClientInvoiceStatusEnum.Paid && !item.IsCopyAction,
        },
        {
          fieldName: 'ReportGroup2',
          label: 'Form Group 2',
          className: 'col-12',
          type: InputTypesEnum.Select,
          validityChecker: ValidityHelper.AlwaysFlawless,
          selectvalues: ClientInvoiceReportGroupOptionsArray,
          hide: (item) => item.Status === TpClientInvoiceStatusEnum.Paid && !item.IsCopyAction,
        },
        {
          fieldName: 'InvoiceComment',
          label: 'Invoice Comments',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => item.Status === TpClientInvoiceStatusEnum.Paid && !item.IsCopyAction,
        },
      ],
    },
  ];

  static onContactChange(editedItem) {
    if (editedItem.ContactId !== EditTpClientInvoiceWindowDescription.lastContactId && !editedItem.isEditing) {
      if (editedItem.ContactId) {
        const contact = editedItem.ClientContacts.find(
          (c) => c.contactId.toString() === editedItem.ContactId.toString()
        );
        editedItem.Vatnumber = contact.vatnumber;
        if (contact.billToClientName) editedItem.BillToClientName = contact.billToClientName;
        else editedItem.BillToClientName = editedItem.ClientName;
        editedItem.OfficeName = contact.officeName;
        editedItem.OfficeId = contact.officeId;
      } else if (!editedItem.ContactId) {
        editedItem.Vatnumber = '';
        editedItem.BillToClientName = '';
      }
    }
    editedItem.isEditing = false;
    EditTpClientInvoiceWindowDescription.lastContactId = editedItem.ContactId;
  }
}
